<template>
  <v-dialog
    :value="value"
    max-width="400"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        Alterar Foto
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-5 text-center">
        <v-avatar
          size="120"
          color="primary"
          class="mb-4"
        >
          <v-img
            v-if="preview"
            :src="preview"
          />
          <span
            v-else
            class="white--text text-h4"
          >
            {{ initials }}
          </span>
        </v-avatar>
        <div>
          <v-btn
            outlined
            small
            class="btn-secondary"
            @click="openFilePicker"
          >
            Escolher foto
          </v-btn>
          <v-btn
            v-if="preview"
            icon
            small
            class="ml-2"
            @click="removeFile"
          >
            <PhTrash :size="18" />
          </v-btn>
        </div>
        <input
          ref="fileInput"
          type="file"
          accept=".jpeg,.jpg,.png"
          class="d-none"
          @change="handleFileSelect"
        />
        <div
          v-if="fileName"
          class="mt-2 text-caption"
        >
          {{ fileName }}
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <Button
          variant="primary"
          :disabled="!selectedFile"
          :loading="uploading"
          @click="save"
        >
          Salvar
        </Button>
        <Button
          variant="tertiary"
          @click="close"
        >
          Cancelar
        </Button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserAvatarApi from '@/api/user/user-avatar-api';

// Components
import Button from '@/components/comum/Button.vue';

// Mixins
import mixinMessage from '@/mixin/mixin-message';

export default {
  name: 'AvatarDialog',
  components: { Button },
  mixins: [mixinMessage],
  inject: ['appData'],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [Number, String],
      default: null
    },
    initials: {
      type: String,
      default: ''
    },
    currentAvatarUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      userAvatarApi: new UserAvatarApi(this.appData.currentUser),
      selectedFile: null,
      preview: null,
      fileName: '',
      uploading: false
    };
  },
  created() {
    this.preview = this.currentAvatarUrl;
  },
  methods: {
    openFilePicker() {
      this.$refs.fileInput?.click();
    },

    handleFileSelect(event) {
      const file = event.target.files?.[0];

      if (!file) return;

      const allowedTypes = ['image/jpeg', 'image/png'];

      if (!allowedTypes.includes(file.type)) {
        this.sendMessage('Formato não permitido. Use JPEG ou PNG.', 'error');

        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.sendMessage('O arquivo não pode ter mais que 5MB.', 'error');

        return;
      }

      this.selectedFile = file;
      this.fileName = file.name;
      this.preview = URL.createObjectURL(file);
    },

    removeFile() {
      this.selectedFile = null;
      this.preview = null;
      this.fileName = '';

      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },

    async save() {
      if (!this.selectedFile) return;

      this.uploading = true;

      try {
        const formData = new FormData();
        formData.append('avatar', this.selectedFile);

        await this.userAvatarApi.upload(this.userId, formData);
        this.sendMessage('Foto atualizada com sucesso.', 'success');
        this.$emit('avatar-updated');
        this.close();
      } catch (error) {
        this.sendErrorMessage(error, 'Não foi possível salvar avatar. Confira os dados e tente novamente; se continuar, fale com o suporte.');
      } finally {
        this.uploading = false;
      }
    },

    close() {
      this.selectedFile = null;
      this.preview = null;
      this.fileName = '';
      this.$emit('input', false);
    }
  }
};
</script>
